import {
  DatatablesFooterServerSide,
  Loading,
  ModalDeleteConfirm,
  TableAction,
  TableCellDefault,
  TableToolbar,
} from "App/Component/ui";

import React, { useState } from "react";
import { deletePembayaranByID, headCells } from "./helpers";
import {
  defaultDateDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  isNull,
  tipeKartuName,
  tipePembayaranName,
} from "App/utils/helpers";

import { Paper, TableCell, TableRow } from "@material-ui/core";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useDatatables, useDatatablesServerSide } from "App/hooks";
import { FreezeTable } from "components/organism";
import { FormContext } from "../../context/FormContext";
import { useContext } from "react";
import { getDetailPembayaranById } from "../helpers";
import ModalIdgl from "App/Component/layout/Wms/PerbekalanFarmasi/TransaksiGudangUtama/PembelianWMS/ui/ModalIdgl/ModalIdgl";
import ModalDetailPembayaran from "./ModalDetailPembayaran/ModalDetailPembayaran";

function TabPembayaran({ setNewData, rows, setRows, loading, setLoading }) {
  const { formData, totalDataPembayaran, setTotalDataPembayaran } =
    useContext(FormContext);

  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [tagihanID, setTagihanID] = useState({
    id_rekap_bayar: "",
  });
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [dataPembayaran, setDataPembayaran] = useState("");

  const clickDelete = async (id) => {
    setTagihanID({
      id_rekap_bayar: id,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  };

  async function deleteList() {
    const res = await deletePembayaranByID(tagihanID);
    if (res.state) {
      defaultToastSuccess(res.message);
      await setNewData();
      setTagihanID({
        id_rekap_bayar: "",
      });
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  const openDetailPembayaran = (row) => {
    setDataPembayaran(row);
    setShowModalDetail(true);
  };

  const setNewDataTabPembayaran = async (pages, limit) => {
    try {
      setLoading(true);
      const response = await getDetailPembayaranById(
        formData.rekap_tagihan_id,
        pages,
        limit
      );
      if (response.state) {
        setRows(response.data);
        setTotalDataPembayaran(response.meta.count);
        setLoading(false);
        if(pages === 1){
          setPagination({
            pages,
            limit,
          })
        }
      } else {
        setRows([]);
        setLoading(false);
        setTotalDataPembayaran(0);
        defaultToastError(response.message);
      }
    } catch (error) {
      setLoading(false);
      defaultToastError(error?.response?.data?.message);
    }
  };

  // const {
  //   page,
  //   setQ,
  //   setPage,
  //   setRowsPerPage,
  //   data,
  //   order,
  //   orderBy,
  //   handleRequestSort,
  //   length,
  //   rowsPerPage,
  // } = useDatatables({
  //   rows: rows,
  //   orderByDefault: "id",
  //   orderByRow: ["id", "idgl", "nama_kas", "no_kartu", "no_transfer"],
  // });

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
    setPagination,
  } = useDatatablesServerSide({ setNewData: setNewDataTabPembayaran });

  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "sisa_tagihan",
    orderByRow: [
      "sisa_tagihan",
      "id_tagihan",
      "nama_rm",
      "rm_id",
      "nama_asuransi",
      "no_asuransi",
    ],
  });

  const [showModalIdgl, setShowModalIdgl] = useState(false);
  const [idGl, setIdGL] = useState("");
  const handleClickIdgl = (idgl) => {
    setIdGL(idgl);
    setShowModalIdgl(!showModalIdgl);
  };

  return (
    <>
      {showModalDetail && (
        <ModalDetailPembayaran
          dataPembayaran={dataPembayaran}
          setDataPembayaran={setDataPembayaran}
          setShowModal={() => setShowModalDetail(false)}
          formData={formData}
          setNewData={setNewData}
        />
      )}
      {showModalIdgl && (
        <ModalIdgl setShowModal={() => setShowModalIdgl(false)} idgl={idGl} />
      )}
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          title={"Hapus Pembayaran Rekap Tagihan"}
          msg={"Apakah anda yakin ingin menghapus data pembayaran ini ?"}
        />
      )}
      <Paper className="p-1">
        <TableToolbar title="Daftar Pembayaran Rekap" />
        <Loading show={loading} />
        {/* <FreezeTableClient
        title="Daftar Pembayaran"
        setQ={setQ}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        withPadding={true}
      > */}
        <FreezeTable
          headCells={headCells}
          handleRequestSort={handleRequestSort}
          order={order}
          length={length}
          orderBy={orderBy}
        >
          {/* {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => { */}
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            return (
              <TableRow hover key={index}>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center">
                  <TableAction
                    isUpdate={false}
                    clickDelete={() =>
                      // clickDelete(row.id, row?.rekap_tagihan_id, row?.idgl)
                      clickDelete(row.id)
                    }
                    isView={true}
                    clickView={() => openDetailPembayaran(row)}
                  />
                </TableCell>
                <TableCell align="left">{row?.id}</TableCell>
                <TableCell align="left">
                  <div
                    style={{
                      display: "flex",
                      gap: "5px",
                      alignItems: "center",
                    }}
                  >
                    {isNull(row?.idgl) ? (
                      <></>
                    ) : (
                      <TableAction
                        isUpdate={false}
                        isDelete={false}
                        isSelect
                        clickSelect={(e) => handleClickIdgl(row?.idgl)}
                      />
                    )}
                    {isNull(row?.idgl) ? <></> : row?.idgl}
                  </div>
                </TableCell>
                <TableCell align="left">
                  {defaultDateDisplay(row?.tanggal_masuk, true)}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(row?.jumlah_bayar)}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(row?.total_diskon)}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(row?.jumlah_bayar + row?.total_diskon)}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(row?.sisa_pembayaran)}
                </TableCell>
                <TableCell align="left">
                  {isNull(row?.nama_kas) ? "-" : row?.nama_kas}
                </TableCell>
                <TableCell align="left">
                  {tipePembayaranName(row.tipe_pembayaran_id)}
                </TableCell>
                <TableCell align="left">
                  {tipeKartuName(row?.tipe_kartu)}
                </TableCell>
                <TableCell align="left">
                  {isNull(row?.no_kartu) ? "-" : row?.no_kartu}
                </TableCell>
                <TableCell align="left">
                  {isNull(row?.no_transfer) ? "-" : row?.no_transfer}
                </TableCell>
                <TableCellDefault row={row} />
              </TableRow>
            );
          })}
          {/* </FreezeTableClient>*/}
        </FreezeTable>
        <DatatablesFooterServerSide
          totalData={totalDataPembayaran}
          pagination={pagination}
          handleChangeLimit={handleChangeLimit}
          onPrevious={onPrevious}
          onNext={onNext}
          currentPage={pagination.page}
          handleClickPageNumber={handleClickPageNumber}
        />
      </Paper>
    </>
  );
}

export default TabPembayaran;
